/*eslint-disable*/
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

function PdfActionButton(props) {

    const handleGeneratePdf = (e) => {
        window.open(props.data.file)
    };

    return (
        <>
            <Button disabled={props.data.file ? false : true} onClick={handleGeneratePdf} basic size="mini" type="button" icon> <Icon name="file pdf" color="red" /></Button>                
        </>
    )
};

export default PdfActionButton;
